import { createSlice } from "@reduxjs/toolkit"

export const attributesListSlice = createSlice({
	name: "attributes_list",
	initialState: {
		attributes: "",
		errors: [],
	},

	reducers: {
        getAttributes: (state, action) => {
            // console.log(action.payload)
			state.attributes = action.payload
		},
		getAttributesList: (state, action) => {
			state.attributes = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getAttributes, getAttributesList, getErrors} = attributesListSlice.actions

export default attributesListSlice.reducer
